import { useState, useEffect, useRef } from "react";

// Props: player (Spotify.Player), currentTrack, isPaused
export default function SpotifyScrubber({ player, currentTrack, isPaused }) {
    const [position, setPosition] = useState(0);
    const [duration, setDuration] = useState(0);
    const [isSeeking, setIsSeeking] = useState(false);
    const seekValueRef = useRef(0);
    const intervalRef = useRef(null);

    // Update duration and position when track changes
    useEffect(() => {
        setDuration(currentTrack?.duration_ms || 0);
        if(currentTrack?.position)
            setPosition(currentTrack?.position);
    }, [currentTrack]);

    // Poll position if not paused and not seeking
    useEffect(() => {
        if (!player || !currentTrack) return;
        if (!isPaused && !isSeeking) {
            intervalRef.current = setInterval(() => {
                player.getCurrentState().then(state => {
                    if (state) {
                        setPosition(state.position);

                    }
                });
            }, 500);
        } else if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        return () => clearInterval(intervalRef.current);
    }, [player, isPaused, currentTrack, isSeeking]);

    // Handle slider change (while dragging or clicking)
    const handleChange = e => {
        const newValue = Number(e.target.value);
        setIsSeeking(true);
        seekValueRef.current = newValue;
        setPosition(newValue);
    };

    // Handle slider release (mouse up or touch end)
    const handleSeekEnd = () => {
        setIsSeeking(false);
        if (player) player.seek(seekValueRef.current);
    };

    // For instant seek on click (not just drag)
    const handleClick = e => {
        const newValue = Number(e.target.value);
        setIsSeeking(false);
        setPosition(newValue);
        seekValueRef.current = newValue;
        if (player) player.seek(newValue);
    };

    // Format ms to mm:ss
    const formatTime = ms => {
        const min = Math.floor(ms / 60000);
        const sec = Math.floor((ms % 60000) / 1000);
        return `${min}:${sec.toString().padStart(2, "0")}`;
    };

    if (!currentTrack) return null;

    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8}}>
            <span style={{ fontSize: 12, color: "#bbb", minWidth: 32 }}>
                {formatTime(position)}
            </span>
            <input
                type="range"
                min={0}
                max={duration}
                value={position}
                onChange={handleChange}
                onMouseUp={handleSeekEnd}
                onTouchEnd={handleSeekEnd}
                onClick={handleClick}
                style={{ flex: 1, accentColor: "#1DB954", cursor: "pointer"}}
            />
            <span style={{ fontSize: 12, color: "#bbb", minWidth: 32 }}>
                {formatTime(duration)}
            </span>
        </div>
    );
}